import React, { Component } from "react";

export default class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      alertMessage: "",
      isLoading: false,
    };
  }

  async submit() {
    if (this.state.isLoading) return;
    if (!this.state.email) {
      this.setState({
        alertMessage: (
          <div className="callout callout-warning">
            <h6>Bitte geben Sie eine E-Mail-Adresse ein.</h6>
          </div>
        ),
      });
      return;
    }
    this.setState({ isLoading: true });
    const headers = { "Content-Type": "application/json" };
    const data = { email: this.state.email };
    try {
      var response = await fetch(global.api_url + "forgot-password", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });
      let jsonRes = await response.json();
      this.setState({
        alertMessage: (
          <div>
            <div className="callout callout-info">
              <h6>{jsonRes.message}</h6>
            </div>
            <p className="mt-3 text-center">
              <a href="#/">Zurück zum Login</a>
            </p>
          </div>
        ),
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        alertMessage: (
          <div>
            <div className="callout callout-danger">
              <h6>Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</h6>
            </div>
            <p className="mt-3 text-center">
              <a href="#/">Zurück zum Login</a>
            </p>
          </div>
        ),
        isLoading: false,
      });
    }
  }

  render() {
    return (
      <div className="login-box" style={{ marginLeft: "auto", marginRight: "auto", marginTop: "5rem" }}>
        <div className="login-logo">
          <img src="dist/img/DIVOKA_Logo.png" alt="DiVoKa Logo" />
        </div>
        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg">Passwort vergessen?</p>
            <form action="" method="post">
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={this.state.email}
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === "Enter") this.submit();
                  }}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-auto">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={this.state.isLoading}
                    onClick={() => this.submit()}
                  >
                    {this.state.isLoading ? "Wird gesendet..." : "Link senden"}
                  </button>
                </div>
              </div>
              <div id="alert-message" className="mt-4">
                {this.state.alertMessage}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}